import React from "react";

import { SonicFacility } from "../../../common/classes/SonicFacility";
import NoResults from "../../../common/NoResults";
import ActionBtn from "../../../common/management/ActionBtn";

import { PageVisibility } from "../../../utils/PageVisibility";
import { genStatusText } from "../../../utils/GeneralUtils";

import styles from "../../management/db-list/DBList.module.scss";

type Props = {
  facilities: SonicFacility[];
};

const FacilityList: React.FC<Props> = ({ facilities }) => {
  if (facilities.length === 0) return <NoResults />;

  return (
    <div className={styles["f-dbList"]}>
      <div
        className={`${styles["f-dbList__category"]} ${styles["head"]} ${styles["facility"]}`}
      >
        <div>施設名</div>
        <div>都道府県</div>
        <div>公開状況</div>
        <div>会員登録</div>
        <div>アクション</div>
      </div>
      {facilities.map((f) => (
        <FacilityListItem
          key={f.id}
          id={f.id}
          name={f.name}
          prefecture={f.prefecture}
          status={f.status}
          ownerName={f.owner?.name}
        />
      ))}
    </div>
  );
};

export default FacilityList;

type ListItemProps = {
  id: string;
  name: string;
  prefecture?: string;
  status: PageVisibility;
  ownerName?: string;
};

const FacilityListItem: React.FC<ListItemProps> = ({
  id,
  name,
  prefecture,
  status,
  ownerName,
}) => {
  const statusStyle = () => {
    switch (status) {
      case PageVisibility.PubliclyVisible:
        return `${styles["status"]} ${styles["open"]}`;
      case PageVisibility.AwaitingInspection:
        return `${styles["status"]} ${styles["pending"]}`;
      default:
        return `${styles["status"]} ${styles["close"]}`;
    }
  };

  return (
    <div
      className={`${styles["f-dbList__category"]} ${styles["body"]} ${styles["facility"]}`}
    >
      <div>{name}</div>
      <div>{prefecture ?? "未設定"}</div>
      <div>
        <span className={statusStyle()}>{genStatusText(status)}</span>
      </div>
      <div>{ownerName ?? "未設定"}</div>
      <div>
        <ActionBtn
          label="詳細"
          icon={["fal", "edit"]}
          link={`/admin/facility/${id}`}
        />
      </div>
    </div>
  );
};
